import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setToken } from "@/store/token.slice";
import { setUser } from "@/store/user.slice";
import { setResturant } from "@/store/resturant.slice";
import { setUpdates } from "@/store/whatsNewSlice";
import WhatsNew from "@/components/whatsNew/WhatsNew";
import { setApps } from "@/store/apps.slice";
import { RootState } from "@/store/store";
import { useUserRole } from "@/hooks/useUserRole";

function ProtectionRoutes({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const token = useSelector(
    (state: { auth: { token: string } }) => state.auth.token,
  );
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const dispatch = useDispatch();
  const [showUpdates, setShowUpdates] = useState(false);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const rerenderTrigger = useSelector(
    (state: RootState) => state.renderProtectionRoute.value,
  );

  const { hasPermission, roleRoutes, isRoleLoaded } = useUserRole();

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    async function authCheck() {
      try {
        setIsLoading(true);

        const response = await axios.get(
          `${baseUrl}/api/dashboard/users/auth`,
          {
            headers: {
              Authorization: token,
            },
          },
        );

        if (response.data.success) {
          setIsAuthenticated(true);
          if (response.data.updates) {
            setShowUpdates(true);
            dispatch(setUpdates(response.data.updates));
          }
          if (response.data.accessToken) {
            dispatch(setToken(response.data.accessToken));
          }
          dispatch(setUser(response.data.userData));
          dispatch(setResturant(response.data.restaurantData));
          dispatch(setApps(response.data.apps));
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.error("Authentication error:", error);
        navigate("/login");
      } finally {
        setIsLoading(false);
      }
    }

    authCheck();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, location.pathname, token, rerenderTrigger]);

  // Permission Check
  useEffect(() => {
    if (
      isAuthenticated &&
      !isLoading &&
      isRoleLoaded &&
      roleRoutes.length > 0
    ) {
      if (!hasPermission(location.pathname)) {
        try {
          navigate(roleRoutes[0]);
        } catch (error) {
          console.error("unexpected error:", error);
          navigate("/not-found");
        }
      }
    }
  }, [
    isAuthenticated,
    isLoading,
    isRoleLoaded,
    hasPermission,
    location.pathname,
    navigate,
    roleRoutes,
  ]);

  // Only render children if authenticated
  if (!isAuthenticated) return null;

  return (
    <>
      {showUpdates && <WhatsNew setShowUpdates={setShowUpdates} />}
      {children}
    </>
  );
}

export default ProtectionRoutes;
